// src/components/TrustSection.jsx
import React from 'react';
import SvgLoader from '../utils/SVGLoader';

const TrustSection = (props) => {
    const content = props.content || {};
    return (
        <section className="w-full relative flex flex-col items-center justify-center px-4 py-10">

            {/* Content */}
            <div className="flex flex-col justify-between md:justify-center items-center w-full h-full z-10 space-y-2">
                <div className="text-center">
                    <h1 className="text-pf-titleDark text-subtitle-sm md:text-subtitle"
                        dangerouslySetInnerHTML={{ __html: content.trust.title }}
                    />
                </div>
                {/* Trustpilot */}
                <div className='flex flex-row items-center justify-center space-x-4 md:space-x-6'>
                    <div className='w-24 md:w-36'>
                        <SvgLoader url={content.trust.starsSetUrl} />
                    </div>
                    <div>
                        <span className='text-body-lg md:text-xl text-pf-titleDark font-medium'>{content.trust.trustPilotRating}</span>
                    </div>
                    <div className='w-24 md:w-32'>
                        <SvgLoader url={content.trust.trustPilotLogoUrl} />
                    </div>
                </div>
                {/* Divider */}
                <div className="wrapper flex-col py-4 md:py-10">
                    <div className="h-px w-full bg-white"></div>
                    <div className="h-px w-full bg-pf-bgDarker"></div>
                </div>
                {/* Divider */}
                {/* Logos */}
                <div className="flex flex-row items-center justify-center md:space-y-0 md:space-x-20 flex-wrap">
                    {content.trust.logos?.map((logo, index) => (
                        <div
                            key={index}
                            className="h-16 flex flex-col items-center justify-center p-4 md:p-0"
                        >
                            <img
                                src={logo.item.src}
                                alt={logo.item.alt}
                                className="w-28 md:w-32"
                            />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default TrustSection;